export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=703ba9114d7104f99ac64b8711c4f5ab0081ce6f1e&name=pushAdClickData!'